import React from 'react';
import styles from '../../common/utils/styles/css/styles';
import Responsive from '../../common/components/basic/Responsive';
import styled, { css } from 'styled-components';
import { Container, MaxWidth } from '../../common/base';

const Description = styled.p`
  text-align: justify;
  color: ${({ theme: { colors } }) => colors.dark.light};
  font-size: 16px;
`;

const K_VALUES = [
  {
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/images/innovation.png',
    width: '70%',
    title: 'Impact<br />through Innovation',
    description: `We Focus on delivering meaningful impact by creating a revolutionary experience through the product and the customer's experience. We push the boundary with our thirst for engineering excellence and perfection.`
  },
  {
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/images/transparent.png',
    width: '100%',
    title: 'Integrity<br />through Transparency',
    description: `We share information openly and proactively. You are responsible and accountable for the work you have agreed so that people can trust you. No politics. You only say things about other employees to their face, not behind their back. You admit mistakes openly.`
  },
  {
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/images/teamwork.png',
    width: '70%',
    title: 'Passion<br />through teamwork and selflessness',
    description: `You fight for what is best for RupiahToken's Vision above group/ team's success and contribute your energy to make it happen. You area quietly confident and openly humble You are acknowledged for your performance and merit- not your tenure, age, or seniority.`
  }
];

export default function Values() {
  return (
    <Container>
      <div
        css={[
          styles.flexWrap,
          css`
            padding-bottom: 80px;
            ${MaxWidth.md`
              flex-direction: column;
            `}
          `
        ]}
      >
        {K_VALUES.map(({ image, width, title, description }) => (
          <div
            key={title}
            css={[
              css`
                margin: 30px;
              `,
              styles.flex1,
              styles.flexDirCol,
              styles.tac
            ]}
          >
            <div>
              <Responsive ratio={1.5}>
                <img width={width} src={image} />
              </Responsive>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: `<p><b>${title}</b></p>`
              }}
            />
            <Description css={styles.ptl}>{description}</Description>
          </div>
        ))}
      </div>
    </Container>
  );
}
